import React from 'react';

import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getDesignCode } from 'common/utils/helpers/systemsValues';

const DesignCode = ({ initialValues }) => {
    const { t } = useTranslation();
    const { system_uid } = initialValues;

    return (
        <Box>
            <Typography variant="caption">
                {t('Design code')}: {getDesignCode(system_uid)}
            </Typography>
        </Box>
    );
};

DesignCode.propTypes = {
    initialValues: PropTypes.object,
};

export default DesignCode;
